import PropTypes from "prop-types";
import React, { createContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import LoginForm from "../pages/Authentication/LoginForms/LoginForm";
import RegisterForm from "../pages/Authentication/RegisterForm";
import { useLoginState } from "../pages/Authentication/useLoginState";
import ListingHeader from "./ListingHeader";
import Footer from "./VerticalLayout/Footer";

// Lets descendants (e.g. ListingChatWidget) open the sign-in modal below
// without prop-drilling through every listing page.
export const ListingAuthContext = createContext({ openSignIn: () => {} });

const ListingLayout = ({ children }) => {
  const [signInOpen, setSignInOpen] = useState(false);
  const [authMode, setAuthMode] = useState("sign-in");
  const loginState = useLoginState();

  const openSignIn = () => {
    setAuthMode("sign-in");
    setSignInOpen(true);
  };

  const closeAuth = () => setSignInOpen(false);

  useEffect(() => {
    document.body.classList.add("listing-layout");
    return () => document.body.classList.remove("listing-layout");
  }, []);

  return (
    <div id="layout-wrapper">
      <ListingHeader onSignIn={openSignIn} />
      <main>
        <ListingAuthContext.Provider value={{ openSignIn }}>
          {children}
        </ListingAuthContext.Provider>
      </main>
      <Footer />
      <Modal isOpen={signInOpen} toggle={() => !loginState.loading && setSignInOpen(false)} centered>
        <ModalHeader toggle={() => !loginState.loading && setSignInOpen(false)}>
          {authMode === "sign-in" ? "Sign in to continue" : "Create your account"}
        </ModalHeader>
        <ModalBody className="p-4">
          {authMode === "sign-in" ? (
            <LoginForm
              loading={loginState.loading}
              setLoading={loginState.setLoading}
              error={loginState.error}
              setError={loginState.setError}
              returnUrl={null}
              mode="tenant"
              navigate={loginState.navigate}
              loginWithGoogle={loginState.loginWithGoogle}
              checkAuth={loginState.checkAuth}
              onSuccess={closeAuth}
              onSignUp={() => { loginState.setError(""); setAuthMode("register"); }}
            />
          ) : (
            <RegisterForm
              navigate={loginState.navigate}
              loginWithGoogle={loginState.loginWithGoogle}
              checkAuth={loginState.checkAuth}
              initialMode="tenant"
              onSuccess={closeAuth}
              onSignIn={() => { loginState.setError(""); setAuthMode("sign-in"); }}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

ListingLayout.propTypes = {
  children: PropTypes.node,
};

export default ListingLayout;